var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ui-button",class:_vm.modifierClass,attrs:{"type":_vm.type}},[(_vm.$slots.icon)?_c('span',{staticClass:"ui-button__icon"},[_vm._t("icon")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }